<template>
  <ul class="title mr-auto flex align-middle tracking-[.12em]">
    <HeaderMainMenuItem
      v-for="menuItem in menu"
      :key="menuItem.id"
      :menu-item="menuItem"
      :is-active="activeItem === menuItem.id"
      :dark="dark || isOpen"
      @set-active-item="setActiveItem(menuItem.id)"
    />
  </ul>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useElementHover } from '@vueuse/core';

import HeaderMainMenuItem from '~/domains/menus/components/HeaderMainMenuItem.vue';

interface Props {
  menu?: any[];
  menuWrapperRef?: any;
  isOpen?: boolean;
  dark?: boolean;
}
interface Emits {
  (e: 'toggle-menu', data: boolean): void;
}

const props = withDefaults(defineProps<Props>(), {
  menu: () => [],
  menuWrapperRef: null,
  isOpen: false,
  dark: false,
});
const emit = defineEmits<Emits>();

const route = useRoute();
const menuRef = computed(() => props.menuWrapperRef);
const isHovered = useElementHover(menuRef);
const activeItem = ref<null | number>(null);

const setActiveItem = (id: number) => {
  activeItem.value = id;
};

watch(isHovered, (value) => {
  if (value === false) activeItem.value = null;
});

watch(
  () => route.fullPath,
  () => {
    activeItem.value = null;
  },
);

watch(activeItem, (value) => {
  emit('toggle-menu', Boolean(value));
});
</script>
